var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUploadIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.4998 13.75V8.74996H15.8332L9.99984 2.91663L4.1665 8.74996H7.49984V13.75H12.4998ZM9.99984 5.27496L11.8082 7.08329H10.8332V12.0833H9.1665V7.08329H8.1915L9.99984 5.27496ZM15.8332 17.0833V15.4166H4.1665V17.0833H15.8332Z",
  fill: "#4E6072"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUploadIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upload-icon.cf759daa.svg";
export { ForwardRef as ReactComponent };